//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { withAuthUser, isLoggedIn } from '@helpers/auth';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';

//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class FooterBottom extends React.Component {
  constructor(props) {
    super(props);
    this.openCookieConsent = this.openCookieConsent.bind(this);
  }

  openCookieConsent(event) {
    event.target = truste.eu && truste.eu.clickListener(2);
  }

  render() {
    const {
      className,
      t,
      location: { pathname },
      __authUser,
    } = this.props;
    const componentClasses = classNames(styles.FooterBottom, {
      [className]: className,
    });
    const copyRightYear = new Date().getFullYear();
    const termsAndConditionsUrl =
      pathname == '/' && !isLoggedIn(__authUser)
        ? t('url_terms_and_conditions_home')
        : t('url_terms_and_conditions');

    return (
      <div className={componentClasses}>
        <p className={styles.Disclosure}>
          &copy; {copyRightYear} {t('footer_ToHome')}{' '}
          {t('footer_AllRightsReserved')}
        </p>
        {termsAndConditionsUrl != '' ? (
          <a
            href={termsAndConditionsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.Link}
          >
            {t('footer_TermsOfService')}
          </a>
        ) : (
          <a className={styles.HideLink}></a>
        )}
        {t('url_privacy_policy') != '' ? (
          <a
            href={t('url_privacy_policy')}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.Link}
          >
            {t('footer_PrivacyPolicy')}
          </a>
        ) : (
          <a className={styles.HideLink}></a>
        )}

        {t('url_donot_sell_my_personal_information') != '' &&
        t('trust_arc_locale') != 'pt-br' ? (
          <a
            rel="noopener noreferrer"
            href={t('url_donot_sell_my_personal_information')}
            target="_blank"
            className={styles.Link}
          >
            {t('footer_DoNotSellPersonalData')}
          </a>
        ) : (
          <a className={styles.HideLink}></a>
        )}

        <a
          className={styles.Link}
          role="button"
          tabIndex="0"
          onClick={this.openCookieConsent}
        >
          {t('footer_CookieConsentTool')}
        </a>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withRouter(withAuthUser(withTranslation()(FooterBottom)));
